import React, { FC, useEffect, useState } from "react";
import GetReservationUrl                  from "../../../../../application/usecase/reservation/GetReservationUrl";
import ReservationUrl                     from "../../../../../domain/reservation/url/ReservationUrl";
import TopSection                         from "../../../common/layout/TopSection";
import ReservationUrlForm                 from "./ReservationUrlForm";
import ReservationUrlPreview              from "./ReservationUrlPreview";

const ReservationUrlTab: FC = () => {
  const [reservationUrl, setReservationUrl] = useState(new ReservationUrl());
  const [loading, setLoading] = useState(false);
  const getReservationUrl: GetReservationUrl = new GetReservationUrl();

  useEffect(() => {
    getReservationUrl.execute(setReservationUrl, setLoading);
  }, []);

  return (
    <>
      <TopSection>
        <ReservationUrlForm
          reservationUrl={ reservationUrl }
          loading={ loading }
        />
      </TopSection>
      <ReservationUrlPreview
        reservationUrl={ reservationUrl }
      />
    </>
  );
};

export default ReservationUrlTab;
